import API from './config'

export const ClientMigrationAPI = {

    /**
     * Duplica o cadastro de um cliente com início de carteira anterior, para receber os
     * lançamentos antigos sem mexer no cadastro em produção. O cadastro novo nasce com
     * in_migration = true, oculto para os usuários do RPPS.
     *
     * @param {number} sourceClientId cliente de origem
     * @param {string} portfolioInit novo início de carteira, no formato DD/MM/YYYY
     */
    async duplicateForMigration(sourceClientId, portfolioInit) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client_migration/duplicate', {
                source_client_id: sourceClientId,
                portfolio_init: portfolioInit,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response ? error.response.data : { message: 'Falha de comunicação com o servidor' }
            };
        }

    },

    /**
     * Liga/desliga a flag de migração. Desligar é a virada: o cadastro passa a aparecer para
     * os usuários do RPPS.
     *
     * @param {number} clientId
     * @param {boolean} inMigration
     */
    async updateMigrationStatus(clientId, inMigration) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/client_migration/updateMigrationStatus', {
                id: clientId,
                in_migration: inMigration,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response ? error.response.data : { message: 'Falha de comunicação com o servidor' }
            };
        }

    },

}
